const id_whs_itemin = {
    "": "barang masuk",
    detail: "detail barang masuk",
}

export default id_whs_itemin;